export default 'trackingPage';
